import { render, staticRenderFns } from "./editAddress.vue?vue&type=template&id=c888f7a6&scoped=true&"
import script from "./editAddress.vue?vue&type=script&lang=js&"
export * from "./editAddress.vue?vue&type=script&lang=js&"
import style0 from "./editAddress.vue?vue&type=style&index=0&id=c888f7a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c888f7a6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
